var map = {
	"./325311D2-FB1B-4A71-A652-19A478F33C81.jpg": 3873,
	"./IMG_0131.JPG": 9014,
	"./IMG_0360.JPG": 394,
	"./IMG_2975(1).jpg": 2047,
	"./IMG_4601.JPG": 3468,
	"./IMG_9737.PNG": 8633,
	"./clay0.jpg": 6885,
	"./clay1.jpg": 9016,
	"./clay2.jpg": 2823,
	"./clay3.jpg": 634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9407;